import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {

		user: {},

		loggedIn: '',

		token: ''
	},

	mutations: {

		userData(state, user){
			state.user = user
		},

		login_status(state, status){
			state.loggedIn = status
		},

		token(state, token){
			state.token = token
		}
	},

	actions: {
		login({commit}, user){

			return new Promise((resolve, reject)=>{

				var request = {
					what: 'login',
					data: user
				}

				Vue.prototype.$socket.makePostRequest(request)

					.then((response)=>{
						if(response.type == 'login' && response.status){
							//console.log(response.data)
							commit('userData', response.data)
							commit('login_status', true)
							//commit('token', response.data.token)
							
							//set the selected menu item to "dashboard" because 
							//this is the first page the user sees after login
							localStorage.setItem('selected', 'dashboard')

							resolve(response)
						} else {
							commit('login_status', false)
							commit('token', null)
							reject('error')
						}
					})
					.catch((error)=>{
						reject('error')
						console.log(error)
					})
			})
		},

		logout({commit}){
			commit('login_status', false)
			commit('userData', null)
			commit('token', null)

			//window.location.reload()
		}
	},

	getters: {

		isLoggedIn: state => state.loggedIn,
		user_data: state => state.user
	},

	plugins: [
		createPersistedState()
	]
})
	